<div class="content-heading">
    <div class="header-Container">
        <h3>Reporte de Etiquetas</h3>
        <small>Reporte Web</small>
    </div>
</div>

<div class="container-fluid">
    <div class="card card-default shadow-sm border-0">
        <div class="card-body">
            <div class="row align-items-end">

                <div class="col-lg-3 col-md-6">
                    <label>Centro de ventas</label>
                    <ng-autocomplete [placeholder]="'Búsqueda'" [disabled]="working" [data]="unitList"
                        [searchKeyword]="'UnitDes'" [itemTemplate]="itemInputTemplate"
                        [notFoundTemplate]="notFoundinputTemplate" [debounceTime]="600" [minQueryLength]="3"
                        (selected)="selectedUnitChange($event)" (inputCleared)="unitCleared()">
                    </ng-autocomplete>

                    <ng-template #itemInputTemplate let-item>
                        <a [innerHTML]="item.UnitDes"></a>
                    </ng-template>
                    <ng-template #notFoundinputTemplate let-notFound>
                        <div [innerHTML]="'No se encontraron coincidencias'"></div>
                    </ng-template>
                </div>

                <div class="col-lg-3 col-md-6">
                    <label class="form-label">Tipo de fecha</label>
                    <aph-custom-select [items]="dateTypeOptions" bindLabel="name"
                        bindValue="id" type="default" placeholder="-- Seleccione una opción --"
                        [selectedValue]="datetype" (returnValue)="datetype = $event">
                    </aph-custom-select>
                </div>

                <div class="col-lg-6 col-md-12">
                    <aph-custom-date-picker [singleMode]="false" labelInicio="Desde" labelFin="Hasta" [maxDate]="today"
                        mode="date" [IsDisabledAll]="downloading" (startDateChange)="minDate = $event"
                        (endDateChange)="maxDate = $event" (onValidationStatus)="isValidRange = $event">
                    </aph-custom-date-picker>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-12">
                    <aph-custom-buttons preset="excel" [label]="downloading ? 'Descargando' : 'Descargar reporte'"
                        [loading]="downloading" [disabled]="!isValidRange" (btnClick)="download()">
                    </aph-custom-buttons>
                </div>
            </div>

        </div>
    </div>
</div>